import { render, staticRenderFns } from "./PlatformWYSIWYG.vue?vue&type=template&id=283a9bd1&scoped=true"
import script from "./PlatformWYSIWYG.vue?vue&type=script&lang=ts"
export * from "./PlatformWYSIWYG.vue?vue&type=script&lang=ts"
import style0 from "./PlatformWYSIWYG.vue?vue&type=style&index=0&id=283a9bd1&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a9bd1",
  null
  
)

export default component.exports